import { Paper, Table, TableCell, TableRow } from "@mui/material";
import { FC, useMemo } from "react";
import './styles.css';

interface CondicoesPagamentoProps {
    dados: any;
    dadosParcela: any[];
}

const CondicoesPagamento: FC<CondicoesPagamentoProps> = ({
    dados,
    dadosParcela,
}) => {
    const avulso = useMemo(()=>{
        return dados?.tipo === "avulso";
    }, [dados?.tipo])
     
    const parcelasCartao: any[] = []
    const parcelas = dadosParcela || []

    parcelas.forEach((parcela: any) => {
        if (dados?.projeto?.valor_servico_pis_cofins !== 0 || dados?.projeto?.valor_servico !== 0) {
            if (parcela?.servicos_pedido?.length > 0 &&
                parcela?.servicos_pedido?.find((sp: any) => sp.servico_pedido !== 'sem_servico') &&
                parcelasCartao.find(p => p === parcela.parcelas) === undefined) {
                parcelasCartao.push(parcela.parcelas);
            }
        } else {
            if (parcela?.servicos_pedido?.length > 0 &&
                parcela?.servicos_pedido.find((sp: any) => sp.servico_pedido === 'sem_servico') &&
                parcelasCartao?.find(p => p === parcela.parcelas) === undefined) {
                parcelasCartao.push(parcela.parcelas);
            }
        }
    })

    const primeiraParcelaComJuros = parcelasCartao?.[0] || '';
    const ultimaParcelaComJuros = parcelasCartao?.[parcelasCartao.length - 1] || '';

    return <>
        <div className="subTitle bg-verde-intelbras text-white title-codicoes-pagamento">Condições de pagamento</div>

        <Table component={Paper} size="small" style={{ width: "100%", borderCollapse: "collapse" }} className="table-codicoes-pagamento">
            <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    Boleto
                </TableCell>
                <TableCell className="tableColEquipamento">
                    À vista
                </TableCell>
            </TableRow>
            <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    PIX
                </TableCell>
                <TableCell className="tableColEquipamento">
                    À vista
                </TableCell>
            </TableRow>
            <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    Múltiplas formas de pagamento
                </TableCell>
                <TableCell className="tableColEquipamento" style={{color: "#494848"}}>
                    <div>PIX e cartão de crédito</div>

                    {(dados?.tipo_faturamento !== 'integrador_cliente' && !avulso) && (
                        <>
                            <div>PIX e financiamento externo</div>
                            <div>PIX e financiamento via Plataforma</div>
                        </>
                    )}

                    <div>Boleto e cartão de crédito</div>

                    {(dados?.tipo_faturamento !== 'integrador_cliente' && !avulso) && (
                        <>
                            <div>Boleto e financiamento externo</div>
                            <div>Boleto e financiamento via Plataforma</div>
                            <div>Cartão de crédito e financiamento externo</div>
                            <div>Cartão de crédito e financiamento via Plataforma</div>
                        </>
                    )}
                </TableCell>
            </TableRow>
            {(dados?.tipo_faturamento !== 'integrador_cliente' && !avulso) && <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    Financiamento bancário*
                </TableCell>
                <TableCell className="tableColEquipamento" style={{color: "#494848"}}>
                    <div>Financiamento direto (via Plataforma)</div>
                    <div>Financiamento indireto (externo)</div>
                </TableCell>
            </TableRow>}
            <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    Cartão de crédito
                </TableCell>
                <TableCell className="tableColEquipamento" style={{color: "#494848"}}>
                    {primeiraParcelaComJuros > 1 ? (
                        <div>em até <strong>{primeiraParcelaComJuros - 1}x</strong> sem juros (Em até dois cartões)</div> 
                    ) : null}
                    {ultimaParcelaComJuros ? (
                        <div>de <strong>{primeiraParcelaComJuros}x</strong> até <strong>{ultimaParcelaComJuros}x</strong> com juros (Em até dois cartões)</div>
                    ) : null}
                </TableCell>
            </TableRow>
        </Table>
    </>
}

export default CondicoesPagamento;